import { render } from "./OrderReasonForChange.vue?vue&type=template&id=2f43174a"
import script from "./OrderReasonForChange.vue?vue&type=script&lang=js"
export * from "./OrderReasonForChange.vue?vue&type=script&lang=js"

import "./OrderReasonForChange.vue?vue&type=style&index=0&id=2f43174a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/misc/OrderReasonForChange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f43174a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f43174a', __exports__)) {
    console.log('reload')
    api.reload('2f43174a', __exports__)
  }
  
  module.hot.accept("./OrderReasonForChange.vue?vue&type=template&id=2f43174a", () => {
    console.log('re-render')
    api.rerender('2f43174a', render)
  })

}


export default __exports__